import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getMessaging } from "firebase/messaging";
import { getAnalytics } from "firebase/analytics";

const firebaseConfig = {
    apiKey: "AIzaSyClXLpjgFRx6LtY8bH-RxC8GQA88k-OisQ",
    authDomain: "the-sample-app-af2e8.firebaseapp.com",
    projectId: "the-sample-app-af2e8",
    storageBucket: "the-sample-app-af2e8.firebasestorage.app",
    messagingSenderId: "283865848669",
    appId: "1:283865848669:web:7e81dfcbc212e58beee6b4",
    measurementId: "G-7X0F7KHDQY"
};

const app = initializeApp(firebaseConfig);

export const db = getFirestore(app);

export const messaging = getMessaging(app);

export const analytics = getAnalytics(app);

navigator.serviceWorker.register("/firebase-messaging-sw.js").then(swReg => {
    console.log("Firebase Worker is registered", swReg);
})